import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the EditusersettPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editusersett',
  templateUrl: 'editusersett.html',
})

export class EditusersettPage {
  User: any
  Title = ''
  _fname: string = ''
  _lname: string = ''
  _email: string = ''
  _phone: string = ''
  _uname: string = ''
  _pass1: string = ''
  _pass2: string = ''
  _sap: string = ''
  tafomaintegration: boolean
  _tafomaintegration: number

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.User = this.navParams.get('user')
    if (this.User.id == -1) {
      this.Title = this.dic.l["newusr"]
    } else {
      this.Title = this.dic.l["editusr"]
      var tmp = this.User.fullname.split(' ')
      if (tmp.length == 2) {
        this._fname = tmp[0]
        this._lname = tmp[1]
      } else {
        this._fname = this.User.fullname
      }
      this._email = this.User.email
      this._phone = this.User.phone
      this._uname = this.User.username
      this._sap = this.User.sapnum
      this._tafomaintegration = this.User.tafomaintegration
      this.tafomaintegration = this._tafomaintegration == 1 ? true : false
    }

  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad EditusersettPage');
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  Save() {
    if (this._fname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["usinfo01"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._email == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["usinfo02"], duration: 3000, position: 'top' });
      toast.present();
      return
    } else {
      if (!this.validateEmail(this._email)) {
        let toast = this.toastCtrl.create({ message: this.dic.l["entervalidemail"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }
    if (this._uname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["usinfo03"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.User.id == -1) {
      var i = /^(?=.*[@$!%*#?&])/;
      //var re = /(?=.*[A-Z])/;
      var re = /^(?=.*[A-Z])/;
      if (this._pass1.length < 6) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordsixch"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (!i.test(this._pass1)) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordspecch"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (!re.test(this._pass1)) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordupper"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      }
      if (this._pass1 != this._pass2) {
        let toast = this.toastCtrl.create({ message: this.dic.l["usinfo04"], duration: 3000, position: 'top' });
        toast.present();
        return
      }

      // if (this._pass1.length < 6) {
      //   let toast = this.toastCtrl.create({ message: this.dic.l["usinfo05"], duration: 3000, position: 'top' });
      //   toast.present();
      //   return
      // }
      //Save add new user
      this.doSave()
    } else {
      if (this._pass1 != "") {
        var i = /^(?=.*[@$!%*#?&])/;
        //var re = /(?=.*[A-Z])/;
        var re = /^(?=.*[A-Z])/;
        if (this._pass1.length < 6) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordsixch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!i.test(this._pass1)) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordspecch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!re.test(this._pass1)) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordupper"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (this._pass1 != this._pass2) {
          let toast = this.toastCtrl.create({ message: this.dic.l["usinfo04"], duration: 3000, position: 'top' });
          toast.present();
          return
        }

        // if (this._pass1.length < 6) {
        //   let toast = this.toastCtrl.create({ message: this.dic.l["usinfo05"], duration: 3000, position: 'top' });
        //   toast.present();
        //   return
        // }
        // Save update with pass
        this.doSave()
      } else {
        // Save update without pass
        this.doSave()
      }
    }

  }

  nnull(_v, _dv) {
    if (_v === null || _v == 'null') {
      return _dv;
    } else {
      return _v;
    }
  }

  sendLink() {
    if (!this.validateEmail(this._uname)) {
      let toast = this.toastCtrl.create({ message: this.dic.l["changeUsernameEmail"], duration: 7000, position: 'top' });
      toast.present();
      return
    } else {
      var _that = this
      this.gn._Post('/api/gn/chekemailresetpass', { eml: this.gn.crypt(this._uname), lng: this.gn.crypt(this.dic.Lang) }, function (_data) {
        if (_data.msg == 'ERROR') {
          let alert = _that.alertCtrl.create({
            title: _that.dic.l["error"],
            subTitle: _that.dic.l["errorresetpass"],
            buttons: [
              {
                text: _that.dic.l['ok'],
                handler: data => {
                  //_that.myEmail = ''
                }
              }
            ]
          });
          alert.present();
        } else {
          let alert = _that.alertCtrl.create({
            title: _that.dic.l["login-fpass"],
            subTitle: _that.dic.l["successresetpass1"] + _that._uname,
            buttons: [
              {
                text: _that.dic.l['ok'],
                handler: data => {
                }
              }
            ]
          });
          alert.present();
        }
      })
    }
  }

  doSave() {
    var _that = this
    var _dat = {
      id: this.gn.crypt(this.User.id),
      fname: this.gn.crypt(this._fname + ' ' + this._lname),
      email: this.gn.crypt(this._email),
      phone: this.gn.crypt(this._phone),
      uname: this.gn.crypt(this._uname),
      pass: this.gn.crypt(this._pass1),
      cid: this.gn.crypt(this.gn.user.ClientId),
      sapnum: this.gn.crypt(this.nnull(this._sap, '')),
      tafomaintegration: this.tafomaintegration == true ? this.gn.crypt('1') : this.gn.crypt('0'),
    }
    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/saveuser', _dat, function (_data) {
      console.log(_data, 'daj da vidam data')
      _that.gn.tfBtn = false;
      //if _data
      // console.log(_data.errorcode)
      if (_data.errorcode == '1') {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["usinfo06"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (_data.errorcode == '2') {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["usinfo07"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      if (_data.errorcode == '0') {
        _that.gn.user.username = _that._uname;
        _that.gn.user.email = _that._email;

        if (_data.priv != undefined) {
          _that.gn.priv = _data.priv;
          for (var i = 0; i < _data.priv.length; i++) {
            var idx = 0;
            for (var key in _data.priv[i]) {
              if (idx > 1) {
                if (_data.priv[i][key] == '1')
                  _that.gn.priv[i][key] = true
                else
                  _that.gn.priv[i][key] = false
              }
              idx++;
            }
          }
        }

        var _cb = _that.navParams.get('cb')
        _cb()
        _that.navCtrl.pop()
        //_that.gn.enableBtn();
      }

      if (_data.newid != -1) {
        _that.gn._Post('/api/gn/updatealarmall', {
          cid: _that.gn.crypt(_that.gn.user.ClientId),
          rid: _that.gn.crypt(_that.gn.user.RoleId),
          uid: _that.gn.crypt(_data.newid)
        }, function (_data2) {
          if (_data2.msg == 'OK') {
            // _that.gn.getNotifications();
            // _that.navCtrl.pop()
            _that.gn.getNotifications();
          }
        })
      }

    })
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/usersettings/editusersett.ts